'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_FORCE_ERROR_QUERY_PARAM, SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_FORCE_LOADING_QUERY_PARAM, SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LOADING_GRACE_MS } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/constants';
import type { SpartanProductExteriorThreesixtyStatusPhase } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/loading-guide/types';
import type { SpartanProductExteriorThreesixtyLoadState } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/types';
interface UseThreesixtyLoadingPhaseParams {
  loadState: SpartanProductExteriorThreesixtyLoadState;
}
export const useThreesixtyLoadingPhase = t0 => {
  const $ = _c(3);
  const {
    loadState
  } = t0;
  const [statusPhase, setStatusPhase] = useState(null);
  let t1;
  let t2;
  if ($[0] !== loadState) {
    t1 = () => {
      const canForceDesignReview = ["dev", "stg"].includes(process.env.NEXT_PUBLIC_ENV ?? "");
      const searchParams = new URLSearchParams(window.location.search);
      const isLoadingForced = canForceDesignReview && searchParams.get(SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_FORCE_LOADING_QUERY_PARAM) === "1";
      if (isLoadingForced) {
        setStatusPhase("loading");
        return;
      }
      const isErrorForced = canForceDesignReview && searchParams.get(SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_FORCE_ERROR_QUERY_PARAM) === "1";
      if (isErrorForced) {
        setStatusPhase("error");
        return;
      }
      if (loadState === "ready") {
        setStatusPhase(null);
        return;
      }
      if (loadState === "error") {
        setStatusPhase("error");
        return;
      }
      setStatusPhase(null);
      const timeoutId = window.setTimeout(() => {
        setStatusPhase("loading");
      }, SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LOADING_GRACE_MS);
      return () => {
        window.clearTimeout(timeoutId);
      };
    };
    t2 = [loadState];
    $[0] = loadState;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return statusPhase;
};